import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import styled from 'styled-components';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { AnchorButton } from 'src/components/core/button';
import { Divider } from 'src/components/divider';
import { ContentContainer, Title, Subtitle } from 'src/components/kiosk-pro/kiosk-pro-shared/kiosk-pro-shared.styles';

export function KioskLoginOptions({
  consumerPhoneLoginUrl,
  phoneLoginUrl,
}: {
  consumerPhoneLoginUrl: string;
  phoneLoginUrl: string;
}): JSX.Element {
  const flags = useFlags();
  const isKioskProPhoneNumberLoginEnabled =
    flags['growth.ecomm.kiosk-pro-consumer-phone-number-log-in.rollout'] ?? false;

  return (
    <KioskLoginOptionsContainer>
      <Title>Login to continue</Title>
      <QrCodeContainer>
        <QRCodeSVG data-testid='qr-code' value={consumerPhoneLoginUrl} size={400} marginSize={2} />
        <Subtitle>
          Scan to login
          <br />
          on your phone
        </Subtitle>
      </QrCodeContainer>

      {isKioskProPhoneNumberLoginEnabled && (
        <>
          <LoginDivider borderSize={2}>or</LoginDivider>
          <PhoneButton href={phoneLoginUrl}>Enter your phone</PhoneButton>
        </>
      )}
    </KioskLoginOptionsContainer>
  );
}

const KioskLoginOptionsContainer = styled(ContentContainer)`
  max-width: 560px;
`;

const QrCodeContainer = styled.div`
  border: 2px solid ${({ theme }) => theme.colors.grey[90]};
  padding: 24px;
  border-radius: 36px;
  width: min-content;
  margin-bottom: 24px;
`;

const LoginDivider = styled(Divider)`
  font-size: clamp(18px, 3vw, 24px);
  color: ${({ theme }) => theme.colors.grey[60]};
  font-weight: 700;
`;

const PhoneButton = styled(AnchorButton)`
  display: block;
  width: 100%;
  margin: 20px auto;
  padding: 30px;
  line-height: 15px;
  font-weight: 700;
  font-size: clamp(24px, 3vw, 36px);
`;
